export default __webpack_public_path__ + "static/moody-logo-cad4ec0930ff2ad74d74602f39ca6bad.png";